const defaultPropertyConfig = `{
  "Default": {
    "db": "{tenant-id}",
    "emailTemplate": "email-template",
    "emailDistribution": ["jason@allpoints.digital","kathleen@allpoints.digital","jamie@allpoints.digital","leadlensai@outlook.com"],
    "skip": false,
    "skipInitialScoring": true,
    "scoreEverything": true,
    "skipEmailNotification": false,
    "validateWebhook": false,
    "useWhisperTranscription": true,
    "allowRepeatCallers": true,
    "alwaysSendEmail": true
  }
}`;

export default defaultPropertyConfig;
